(function () {
  'use strict';

  const config = window.ProtectedCollectionConfig;

  if (!config) {
    return;
  }

  const root = document.querySelector(
    '[data-protected-collection]'
  );

  if (!root) {
    return;
  }

  const gate = root.querySelector(
    '[data-password-gate]'
  );

  const passwordForm = root.querySelector(
    '[data-password-form]'
  );

  const passwordInput = root.querySelector(
    '[data-password-input]'
  );

  const passwordError = root.querySelector(
    '[data-password-error]'
  );

  const requestForm = root.querySelector(
    '[data-request-form]'
  );

  const showRequestButton = root.querySelector(
    '[data-show-request]'
  );

  const hideRequestButton = root.querySelector(
    '[data-hide-request]'
  );


  /*
   * All sections after the protected gate
   * belong to the protected collection.
   */
  function getProtectedSections() {

    const sections = [];

    let element = root.closest(
      '.shopify-section'
    );

    if (!element) {
      return sections;
    }

    let next = element.nextElementSibling;

    while (next) {

      if (
        next.id &&
        next.id.includes('shopify-section')
      ) {
        sections.push(next);
      }

      next = next.nextElementSibling;
    }

    return sections;
  }


  /*
   * Hide normal collection sections.
   */
  function hideCollectionSections() {

    const sections =
      getProtectedSections();

    sections.forEach(function (section) {

      section.setAttribute(
        'data-protected-hidden',
        'true'
      );

      section.hidden = true;

    });

  }


  /*
   * LOCKED STATE
   *
   * Hide everything except protected collection.
   */
  function setLockedState() {

    document.body.classList.remove(
      'protected-collection-unlocked'
    );

    document.body.classList.add(
      'protected-collection-locked'
    );

  }

    /*
   * UNLOCKED STATE
   *
   * Hide protected collection.
   *
   * Normal collection sections become visible.
   */
  function setUnlockedState() {

    document.body.classList.remove(
      'protected-collection-locked'
    );

    document.body.classList.add(
      'protected-collection-unlocked'
    );

  }
  /*
   * Show normal collection sections.
   */
  function showCollectionSections() {

    const sections =
      getProtectedSections();

    sections.forEach(function (section) {

      section.removeAttribute(
        'data-protected-hidden'
      );

      section.hidden = false;

    });

  }


  /*
   * SHA-256.
   */
  async function sha256(value) {

    const encoder =
      new TextEncoder();

    const data =
      encoder.encode(value);

    const hash =
      await crypto.subtle.digest(
        'SHA-256',
        data
      );

    return Array
      .from(new Uint8Array(hash))
      .map(function (byte) {
        return byte
          .toString(16)
          .padStart(2, '0');
      })
      .join('');

  }


  /*
   * Session key.
   */
  const storageKey =
    `${config.storageKey}_${config.collectionHandle}`;


  /*
   * Check authentication.
   */
  function hasAccess() {

    return sessionStorage.getItem(
      storageKey
    ) === 'true';

  }


  /*
   * Unlock collection.
   */
  function unlockCollection() {

    sessionStorage.setItem(
      storageKey,
      'true'
    );

    if (gate) {
      gate.hidden = true;
    }

    if (requestForm) {
      requestForm.hidden = true;
    }

    showCollectionSections();
setUnlockedState();
  }


  /*
   * Password submit.
   */
  passwordForm?.addEventListener(
    'submit',
    async function (event) {

      event.preventDefault();

      if (passwordError) {
        passwordError.hidden = true;
      }

      const password =
        passwordInput?.value.trim();

      if (!password) {
        return;
      }

      try {

        const hash =
          await sha256(password);

        if (
          hash ===
          config.passwordHash
        ) {

          unlockCollection();

          return;
        }


        if (passwordError) {
          passwordError.hidden = false;
        }

        passwordInput.value = '';

        passwordInput.focus();

      } catch (error) {

        console.error(
          'Password verification failed:',
          error
        );

      }

    }
  );


  /*
   * Request access.
   */
  showRequestButton?.addEventListener(
    'click',
    function () {

      if (gate) {
        gate.hidden = true;
      }

      if (requestForm) {
        requestForm.hidden = false;
      }

    }
  );


  /*
   * Back.
   */
  hideRequestButton?.addEventListener(
    'click',
    function () {

      if (requestForm) {
        requestForm.hidden = true;
      }

      if (gate) {
        gate.hidden = false;
      }

    }
  );


  /*
   * INITIAL STATE
   */
  if (hasAccess()) {

    unlockCollection();
 setUnlockedState();
  } else {

    hideCollectionSections();
  setLockedState();
  }
  

})();